<template>
    <div class="agreement">
        <agreement-modal
            :title="info[type].title"
            :html="info[type].html"
            @close="closeAgreementModal"
            v-if="agreementContentsModal"
        />
        <div class="header" @click="gohome">← 홈화면으로 돌아가기</div>
        <div class="wrapper">
            <div class="agree-area">
                <div class="title">건강 측정 체험을 위해<br><span style="font-weight: 700;">약관 동의가 필요합니다</span></div>
                <div class="agree-component" style="margin-top: 4.6vh;">
                    <div class="text2">
                        <div class="row">
                            <span @click="agree1 = !agree1">[필수] 만 14세 이상입니다.</span>
                        </div>
                    </div>
                    <div class="text2" @click="agreementContentsView(0)">
                        <div class="row">
                            <span @click="agree2 = !agree2">[필수] 서비스 이용약관 동의</span>
                        </div>
                        <img style="width: 5vw;" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                    <div class="text2"  @click="agreementContentsView(1)">
                        <div class="row">
                            <span @click="agree3 = !agree3">[필수] 개인정보 수집 및 이용동의</span>
                        </div>
                        
                        <img style="width: 5vw;" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                    <div class="text2"  @click="agreementContentsView(2)">
                        <div class="row">
                            <span @click="agree4 = !agree4">[필수] 위치기반 서비스 이용동의</span>
                        </div>
                        <img style="width: 5vw;" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                </div>
                <div class="button-next-active" style="margin-top: 4.6vh;" @click="next">모두 동의합니다</div>
            </div>
        </div>
    </div>
</template>

<script>

import AgreementModal from '@/components/showcase/AgreementModal';
export default {
    components: { AgreementModal },
    data: function()
    {
        return {
            timerId: null,
            allAgree: false,
            agree1: false,
            agree2: false,
            agree3: false,
            agree4: false,
            agreementContentsModal: false,
            type: 0,
            info: [
                {title: "서비스 이용약관 동의", html: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>서비스 이용약관</title>
    <style>
        body {
            font-size: 15px;
            word-break: break-word;
        }

        p {
            word-break: break-word;
        }
         table, th, td {
            border: 1px solid #333333;
            border-collapse: collapse;
         }
         .content {
            text-align: center;
         }
         .number {
            text-align: right;
         }
         .title { 
            font-size: 20px;
            font-weight: bold;
         }
    </style>
</head>
<body>
    <h1>[솔닥 운영원칙]</h1>
솔닥 주식회사에서 운영하는 솔직한닥터, ‘솔닥’ 서비스는 관련 법령 등에 따라 시행되는 비대면진료 시범사업에 관한 사항을 준수하는 진료 중개 플랫폼 서비스로서, 의료 전문가들이 서비스 이용자와 소통하며 바른 의학정보를 제공할 수 있도록 합니다.<br><br>
솔닥은 ‘솔닥’ 서비스 이용자들의 일상속 건강증진을 위해 적극적인 소통과 바른 정보를 제공할 것을 약속드립니다.<br><br>
솔닥은 비대면진료 시범사업에 따라 허용된 진료를 중개하는 시스템을 제공할 뿐, ‘솔닥’ 서비스 이용자들과 의료진 간 진료 행위 및 이용자 본인의 건강에 관한 의사 결정에 책임을 지지 않습니다.<br><br>

<h3>[중개사업자 면책 및 책임범위]</h3>
사이버몰 내 판매되는 상품 중에는 솔닥에 등록한 개별 판매자가 판매하는 상품이 포함되어 있습니다.<br>
개별판매자가 판매하는 상품의 경우 솔닥은 통신판매중개자이며 통신판매의 당사자가 아닙니다.<br>
솔닥은 개별판매자의 상품, 거래정보 및 거래 등에 대하여 책임을 지지 않습니다.<br>
솔닥은 소비자 보호와 안전거래를 위해 고객센터를 운영하고 있으며, 관련 분쟁이 발생할 경우 별도의 분쟁처리절차에 의거 분쟁이 처리됩니다.<br><br>

<h3>[이용약관]</h3>
회사의 회원약관은 다음과 같은 내용을 담고 있습니다.<br>
제 1조 목적<br>
제 2조 정의<br>
제 3조 약관등의 명시와 설명 및 개정<br>
제 4조 서비스의 제공 및 변경<br>
제 5조 서비스의 중단<br>
제 6조 회원가입<br>
제 7조 회원 탈퇴 및 자격 상실 등<br>
제 8조 회원에 대한 통지<br>
제 9조 구매신청<br>
제 10조 계약의 성립<br>
제 11조 지급방법<br>
제 12조 수신확인통지·구매신청 변경 및 취소<br>
제 13조 재화등의 공급<br>
제 14조 환급<br>
제 15조 청약철회 등<br>
제 16조 청약철회 등의 효과<br>
제 17조 개인정보보호<br>
제 18조 "플랫폼"의 의무<br>
제 19조 회원의 ID 및 비밀번호에 대한 의무<br>
제 20조 이용자의 의무<br>
제 21조 연결"플랫폼"과 피연결"플랫폼" 간의 관계<br>
제 22조 "플랫폼" 제공 컨텐츠의 저작권 보호<br>
제 23조 분쟁해결<br>
제 24조 재판권 및 준거법<br>
제 25조 쿠폰의 사용<br>
제 26조 솔닥복권의 사용<br>
부칙<br><br>

<h3>제 1조(목적)</h3>
이 약관은 솔닥 주식회사(이하 “회사”)가 운영하는 ‘솔닥’ 서비스 즉, 솔닥 플랫폼 서비스와 솔닥 컨시어지서비스(이하 총칭하여 “서비스”), 솔닥 제휴 서비스 이용과 관련하여 회사와 이용자의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.<br><br>

<h3>제 2조(정의)</h3>
① "플랫폼"이란 회사가 컴퓨터 등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 플랫폼을 운영하는 사업자의 의미로도 사용합니다.<br>
② “솔닥 제휴 서비스”란 제휴사 앱/플랫폼을 통해 솔닥의 특정 기능을 호출 및 이용하는 연계형 서비스를 말합니다.<br>
③ “제휴사”란, 솔닥과 계약에 따라 솔닥 제휴 서비스를 제공하는 사업자를 말합니다.<br>
④ "이용자"란 "플랫폼"에 접속하여 이 약관에 따라 "플랫폼"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.<br>
⑤ ”회원”이라 함은 "플랫폼"에 개인정보를 제공하여 회원등록을 한 만 14세 이상의 자로서, "플랫폼"의 정보를 지속적으로 제공받으며, "플랫폼"이 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.<br>
⑤ ”비회원”이라 함은 회원에 가입하지 않고 "플랫폼"이 제공하는 서비스를 이용하는 자를 말합니다.<br>
⑥ ”솔닥 챌린지”란 “솔닥 제휴 서비스”에서 제공되는 기능으로, 이용자가 서비스 내 특정 행위를 완료할 경우 자동으로 복권이 발급되고, 해 복권을 사용하여 회사가 제공하는 경품에 응모할 수 있는 기능을 말합니다.<br>
⑦ “솔닥복권”이란 솔닥 챌린지에 따라 발급되는 응모권으로, 유효기간 내 경품 응모에 사용할 수 있습니다.<br>
⑧ “경품”이란 회사가 사전에 고지한 확률에 따라 당첨 또는 미당첨이 결정되는 디지털 바우처 등 상품권을 말합니다.<br><br>

<h3>제 3조(약관등의 명시와 설명 및 개정)</h3>
① "플랫폼"은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호·모사전송번호·전자우편주소, 사업자등록번호, 통신판매업신고번호, 개인정보 보호책임자등을 이용자가 쉽게 알 수 있도록 솔닥의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.<br>
② "플랫폼"은 이용자가 약관에 동의하기에 앞서 약관 내용 중 청약철회·배송책임·환불조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다.<br>
③ "플랫폼"은 전자상거래등에서의소비자보호에관한법률, 약관의규제에관한법률, 전자문서및전자거래기본법, 전자금융거래법, 전자서명법, 정보통신망이용촉진및정보보호등에관한법률, 방문판매등에관한법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br>
④ "플랫폼"이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 플랫폼의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.<br>
다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 "플랫폼"은 개정전 내용과 개정후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.<br>
⑤ "플랫폼"이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간내에 "플랫폼"에 송신하여 "플랫폼"의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.<br>
⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한 법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자보호지침 및 관계법령 또는 상관례에 따릅니다.<br><br>

<h3>제 4조(서비스의 제공 및 변경)</h3>
① "플랫폼"은 다음과 같은 업무를 수행합니다.<br>
1. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결<br>
2. 구매계약이 체결된 재화 또는 용역의 배송<br>
3. 이용자의 진료(비대면/대면)비대면진료 예약, “플랫폼” 파트너십 업체를 통한 진료 제휴 서비스(비대면/대면 진료) 비대면진료 제휴 서비스, 처방, 결제, 진료 내역 관리, 의약품 배송 및 비대면/대면 진료 서비스 간 취합된 데이터 제공<br>
4. 맞춤형 건강정보 제공▪관리, 칼럼 등 건강 컨텐츠 제공<br>
5. 당뇨 환자를 위한 비대면진료 및 관련 서비스 제공<br>
6. 유전자검사 서비스 및 관련 서비스 제공<br>
7. 건강검진, 진료내역 등 건강 관련 정보 제공 서비스<br>
8. 기타 "플랫폼"이 정하는 업무<br>
② "플랫폼"은 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및 제공일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지합니다.<br>
③ "플랫폼"이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.<br>
④ 전항의 경우 "플랫폼"은 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, "플랫폼"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.<br>
⑤ 건강정보와 관련된 내용은 대한민국 의료 관련 제반 법령과 보건복지부의 가이드라인에 따른 전문가의 지식에 기반한 의견 또는 개인적 생각으로 이것이 진단 등과 같은 의료적 행위가 아닌 조언이므로 참고 목적으로만 사용되어야 하고, 이용자가 병원을 직접 방문하여 의사와 진찰과정을 통하여 취득한 진료결과나 건강진단결과, 처방결과를 대신하지 못하며, 솔닥은 그 책임을 지지 않습니다.<br><br>

<h3>제 5조(서비스의 중단)</h3>
① "플랫폼"은 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.<br>
② "플랫폼"은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, "플랫폼"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.<br>
③ 사업종목의 전환, 사업의 포기, 업체간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 "플랫폼"은 제8조에 정한 방법으로 이용자에게 통지하고 당초 "플랫폼"에서 제시한 조건에 따라 소비자에게 보상합니다. 다만, "플랫폼"이 보상기준 등을 고지하지 아니한 경우에는 이용자들의 마일리지 또는 적립금 등을 "플랫폼"에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 이용자에게 지급합니다.<br><br>

<h3>제 6조(회원가입)</h3>
① 이용자는 "플랫폼"이 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.<br>
② "플랫폼"은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.<br>
1. 가입신청자가 만 14세 미만인 경우<br>
2. 가입신청자가 이 약관 제7조제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 "플랫폼"의 회원재가입 승낙을 얻은 경우에는 예외로 한다.<br>
3. 등록 내용에 허위, 기재누락, 오기가 있는 경우<br>
4. 기타 회원으로 등록하는 것이 "플랫폼"의 기술상 현저히 지장이 있다고 판단되는 경우<br>
③ 회원가입계약의 성립시기는 "플랫폼"의 승낙이 회원에게 도달한 시점으로 합니다.<br>
④ 회원은 회원 가입시 등록한 사항에 변경이 있는 경우, 상당한 기간 이내에 "플랫폼"에 대하여 회원정보 수정 등의 방법으로 그 변경사항을 알려야 합니다.<br><br>

<h3>제 7조(회원 탈퇴 및 자격 상실 등)</h3>
① 회원은 "플랫폼"에 언제든지 탈퇴를 요청할 수 있으며 "플랫폼"은 회원 요청에 따라 지체없이 회원탈퇴에 필요한 제반 절차를 진행합니다. 단 회원의 탈퇴 요청 시점에 처리되지 않은 서비스 이용 요금 또는 미결제 내역(이하 "미결제 이용요금")이 있거나, 회원 계정 내에 '진료예약' 상태의 진료 일정이 존재하는 경우, "플랫폼"은 다음 각 호에 따라 회원탈퇴 요청을 처리합니다.<br>
1. 회원에게 미결제 이용요금이 존재하는 경우, 회원이 미결제 이용요금을 완납할 경우에 회원탈퇴 처리됩니다.<br>
2. 회원 계정에 ‘진료예약’ 상태의 진료 일정이 존재하는 경우, 회원이 계정 내 '진료예약'을 모두 취소할 경우에 회원탈퇴 처리됩니다.<br>
② 회원이 다음 각호의 사유에 해당하는 경우, "플랫폼"은 회원자격을 제한 및 정지시킬 수 있습니다.<br>
1. 가입 신청시에 허위 내용을 등록한 경우<br>
2. "플랫폼"을 이용하여 구입한 재화 등의 대금, 기타 "플랫폼" 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우<br>
3. 다른 사람의 "플랫폼" 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우<br>
4. "플랫폼"을 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우<br>
5. 만 14세 미만인 경우<br>
③ "플랫폼"이 회원 자격을 제한·정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 "플랫폼"은 회원자격을 상실시킬 수 있습니다.<br>
④ "플랫폼"이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.<br>
⑤ 회원이 회원탈퇴를 신청하는 경우, 보유 중인 솔닥복권 및 미사용•미지급 상태의 당첨 권리는 즉시 소멸하며 복구되지 않습니다. 탈퇴 후 재가입하더라도 소멸된 권리는 복권되지 않습니다.<br><br>

<h3>제 8조(회원에 대한 통지)</h3>
① "플랫폼"이 회원에 대한 통지를 하는 경우, 회원이 "플랫폼"과 미리 약정하여 지정한 전자우편 주소로 할 수 있습니다.<br>
② "플랫폼"은 불특정다수 회원에 대한 통지의 경우 1주일이상 "플랫폼" 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.<br><br>

<h3>제 9조(구매신청)</h3>
"플랫폼"이용자는 "플랫폼"상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, "플랫폼"은 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다. 단, 회원인 경우 제2호 내지 제4호의 적용을 제외할 수 있습니다.<br>
1. 재화 등의 검색 및 선택<br>
2. 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력<br>
3. 약관내용, 청약철회권이 제한되는 서비스, 배송료·설치비 등의 비용부담과 관련한 내용에 대한 확인<br>
4. 이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)<br>
5. 재화등의 구매신청 및 이에 관한 확인 또는 "플랫폼"의 확인에 대한 동의<br>
6. 결제방법의 선택<br><br>

<h3>제 10조 (계약의 성립)</h3>
① "플랫폼"은 제9조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.<br>
1. 신청 내용에 허위, 기재누락, 오기가 있는 경우<br>
2. 미성년자가 담배, 주류 등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우<br>
3. 기타 구매신청에 승낙하는 것이 "플랫폼" 기술상 현저히 지장이 있다고 판단하는 경우<br>
② "플랫폼"의 승낙이 제12조제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.<br>
③ "플랫폼"의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매 가능 여부, 구매신청의 정정 취소 등에 관한 정보 등을 포함하여야 합니다.<br><br>

<h3>제 11조(지급방법)</h3>
"플랫폼"에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각호의 방법 중 가용한 방법으로 할 수 있습니다. 단, "플랫폼"은 이용자의 지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다.<br>
1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체<br>
2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제<br>
3. 온라인무통장입금<br>
4. 전자화폐에 의한 결제<br>
5. 수령시 대금지급<br>
6. 마일리지 등 "플랫폼"이 지급한 포인트에 의한 결제<br>
7. "플랫폼"과 계약을 맺었거나 "플랫폼"이 인정한 상품권에 의한 결제<br>
8. 기타 전자적 지급 방법에 의한 대금 지급 등<br><br>

<h3>제 12조(수신확인통지·구매신청 변경 및 취소)</h3>
① "플랫폼"은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.<br>
② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 "플랫폼"은 배송 전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한 경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다.<br><br>

<h3>제 13조(재화등의 공급)</h3>
① "플랫폼"은 이용자와 재화등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, "플랫폼"이 이미 재화 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 2영업일 이내에 조치를 취합니다. 이때 "플랫폼"은 이용자가 재화 등의 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.<br>
② "플랫폼"은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 "플랫폼"이 약정 배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상하여야 합니다. 다만 "플랫폼"이 고의·과실이 없음을 입증한 경우에는 그러하지 아니합니다.<br><br>

<h3>제 14조(환급)</h3>
"플랫폼"은 이용자가 구매신청한 재화등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 2영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.<br><br>

<h3>제 15조(청약철회 등)</h3>
① "플랫폼"과 재화등의 구매에 관한 계약을 체결한 이용자는 수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있습니다.<br>
② 이용자는 재화 등을 배송받은 경우 다음 각호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.<br>
1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있습니다)<br>
2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우<br>
3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우<br>
4. 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우<br>
③ 제2항제2호 내지 제4호의 경우에 "플랫폼"이 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회등이 제한되지 않습니다.<br>
④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.<br><br>

<h3>제 16조(청약철회 등의 효과)</h3>
① "플랫폼"은 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다. 이 경우 "플랫폼"이 이용자에게 재화 등의 환급을 지연한 때에는 그 지연기간에 대하여 공정거래위원회가 정하여 고시하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.<br>
② "플랫폼"은 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다.<br>
③ 청약철회등의 경우 공급받은 재화 등의 반환에 필요한 비용은 이용자가 부담합니다. "플랫폼"은 이용자에게 청약철회등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 재화 등의 반환에 필요한 비용은 "플랫폼"이 부담합니다.<br>
④ 이용자가 재화 등을 제공받을때 발송비를 부담한 경우에 "플랫폼"은 청약철회시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게 표시합니다.<br><br>

<h3>제 17조(개인정보보호)</h3>
① "플랫폼"은 이용자의 정보수집시 구매계약 이행, 서비스 제공을 위하여 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외 사항은 선택사항으로 합니다.<br>
1. 성명<br>
2. 주소<br>
3. 전화번호<br>
4. 생년월일<br>
5. 희망ID(회원의 경우)<br>
6. 비밀번호(회원의 경우)<br>
7. 전자우편주소(또는 이동전화번호)<br>
② "플랫폼"이 이용자의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.<br>
③ 제공된 개인정보는 당해 이용자의 동의없이 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 플랫폼이 집니다. 다만, 다음의 경우에는 예외로 합니다.<br>
1. 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우<br>
2. 계약의 체결 및 이행을 위하여 불가피하게 필요한 경우<br>
3. 재화, 서비스 등의 거래에 따른 대금 정산을 위하여 필요한 경우<br>
4. 배송 업무 상 배송업체에게 배송에 필요한 최소한의 이용자의 정보(성명, 주소, 전화번호)를 알려주는 경우<br>
5. 수사기관이 수사 목적을 위해 관계법령이 정한 절차를 거쳐 요구하는 경우<br>
6. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우<br>
④ "플랫폼"이 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보 보호책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은 자, 제공목적 및 제공할 정보의 내용) 등 개인정보보호법 제17조제2항, 제18조제3항이 규정한 사항을 알려야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.<br>
⑤ 이용자는 언제든지 "플랫폼"이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 "플랫폼"은 이에 대해 지체없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 "플랫폼"은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.<br>
⑥ "플랫폼"은 개인정보 보호를 위하여 이용자의 개인정보 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.<br>
⑦ "플랫폼" 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체없이 파기합니다.<br><br>

<h3>제 18조("플랫폼"의 의무)</h3>
① "플랫폼"은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는데 최선을 다하여야 합니다.<br>
② "플랫폼"은 이용자와 의료인, 약사의 개인정보를 개인정보보호법·의료법·약사법 등 관련 법령에 따라 보호합니다. 이를 위해 “플랫폼”은 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.<br>
③ "플랫폼"이 상품이나 용역에 대하여 「표시·광고의공정화에관한법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.<br>
④ "플랫폼"은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.<br>
⑤ "플랫폼"은 진료 서비스 제공 및 이용의 편의 증진을 도모하기 위하여 의료법·약사법 등 관련 법령 및 보건복지부 가이드라인을 준수하여 사업을 영위하여야 합니다.<br><br>

<h3>제 19조(회원의 ID 및 비밀번호에 대한 의무)</h3>
① 제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.<br>
② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.<br>
③ 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 "플랫폼"에 통보하고 "플랫폼"의 안내가 있는 경우에는 그에 따라야 합니다.<br><br>

<h3>제 20조(이용자의 의무)</h3>
이용자는 다음 행위를 하여서는 안됩니다.<br>
1. 신청 또는 변경시 허위 내용의 등록<br>
2. 타인의 정보 도용<br>
3. "플랫폼"에 게시된 정보의 변경<br>
4. "플랫폼"이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시<br>
5. "플랫폼" 기타 제3자의 저작권 등 지적재산권에 대한 침해<br>
6. "플랫폼" 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br>
7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 플랫폼에 공개 또는 게시하는 행위<br><br>

<h3>제 21조(연결"플랫폼"과 피연결"플랫폼" 간의 관계)</h3>
① 상위 "플랫폼"과 하위 "플랫폼"이 하이퍼링크(예: 하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우, 전자를 연결 "플랫폼"(웹 사이트)이라고 하고 후자를 피연결 "플랫폼"(웹사이트)이라고 합니다.<br>
② 연결"플랫폼"은 피연결"플랫폼"이 독자적으로 제공하는 재화 등에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지 않는다는 뜻을 연결"플랫폼"의 초기화면 또는 연결되는 시점의 팝업화면으로 명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다.<br><br>

<h3>제 22조("플랫폼" 제공 컨텐츠의 저작권 보호)</h3>
① 솔닥에서 제공하는 각종 서비스의 내용을 보호하고, 저작권 등 타인의 권리를 침해하지 않도록 하기 위하여 다음과 같은 저작권 정책을 운영하고 있으니, 회원 및 솔닥 이용 고객 분들은 이를 살펴보시고 숙지하시어 타인의 권리를 침해하지 않도록 하시기 바랍니다.<br>
1. 게시물의 저작권 귀속 및 책임<br>
- 회원이 작성하여 서비스에 게재 또는 등록한 답변, 자료, 사진 등에 대한 저작권은 회원 본인에게 있는 것으로 추정되며, 게시물이 타인의 저작권 등 지적재산권을 침해하는 경우 그에 대한 책임은 회원 본인이 부담합니다.<br>
- 회사가 저작권을 가지고 있는 게시물을 이용하는 경우에는 학술, 연구 등 개인적 목적으로만 이용하여야 하며, 회사의 명시적 동의 없이 게시물의 전부 또는 일부를 복제, 배포, 전송 등의 방법으로 이용하거나 영리적 목적으로 이용하는 경우에는 민사상의 책임뿐만 아니라 형사처벌을 받을 수도 있습니다.<br>
2. 회원 및 제3자의 저작권 보호<br>
- 저작권자의 명시적 동의 없이 타인의 저작물(컴퓨터프로그램 포함. 이하 같습니다)의 전부 또는 일부를 복제, 배포, 전송 등의 방법으로 이용하는 것은 저작권자의 권리를 침해하는 행위이므로, 복제/배포/전송 등의 방법으로 타인의 저작권을 침해하는 게시물을 “플랫폼”에 게재 또는 등록하여서는 아니 됩니다.<br>
- 타인의 저작물을 인용한 게시물인 경우 그 인용 부분이 회원 개인의 의견을 뒷받침하기 위해 일부 인용된 것이 아니라 게시물의 핵심적인 부분을 구성하고 있다면 출처를 밝히더라도 저작권 침해에 해당되므로, 저작권자의 명시적 동의 없이 이러한 게시물을 “플랫폼”에 게재 또는 등록하여서는 아니 됩니다.<br>
- “플랫폼” 서비스에 게재 또는 등록된 회원의 게시물을 제3자가 사용하고자 할 경우에는 반드시 해당 회원의 명시적 동의를 얻은 뒤 사용하여야 합니다.<br>
- “플랫폼”은 회원이 서비스 이용과정에서 타인의 저작권, 상표권, 의장권 등 지적 재산권을 침해하는 경우 어떠한 책임도 부담하지 않습니다.<br>
- 서비스 상의 게시물은 회원들간의 지식공유를 위해 회원이 게재한 것이므로 회사는 게시물에 대한 정확성에 대해서는 보증을 하지 않습니다.<br>
- “플랫폼”은 회원들의 게시물 이용에 따른 동의절차를 중개하거나 그 과정에 개입하지 않습니다.<br>
3. 게시물의 중단 및 재개 요청<br>
- 저작권 침해 신고에 관한 사항은 고객센터 또는 메일을 통해 연락 주시기 바랍니다.<br><br>

<h3>제 23조(분쟁해결)</h3>
① "플랫폼"은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.<br>
② "플랫폼"은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.<br>
③ "플랫폼"과 이용자간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.<br><br>

<h3>제 24조(재판권 및 준거법)</h3>
① "플랫폼"과 이용자간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.<br>
② "플랫폼"과 이용자간에 제기된 전자상거래 소송에는 한국법을 적용합니다.<br><br>

<h3>제25조(쿠폰의 사용)</h3>
① “플랫폼”은 회원의 재화 등의 구매, 이벤트 참여 등 일정한 서비스 이용을 조건으로, 서비스 내 공지사항 또는 운영정책에서 명시한 바에 따라 일정 금액 또는 일정 비율의 할인을 받을 수 있는 쿠폰을 제공할 수 있습니다.<br><br>
② 쿠폰의 부여 방식, 사용 조건, 유효기간 등은 “플랫폼”에서 정한 쿠폰 운영정책에 따릅니다. "플랫폼"은 별도 상세페이지를 통하여 이를 회원에게 안내합니다.<br><br>
③ 회원은 본인의 거래에 대해서만 쿠폰을 사용할 수 있으며, 타인에게 매매·양도하거나, 실질적으로 동일한 행위를 하여서는 안 됩니다.<br><br>
④ 쿠폰은 명시된 유효기간 내에서만 사용할 수 있으며,  유효기간이 만료된 무상 쿠폰은 복구 및 재사용이 불가합니다. 단 회원이 유상 대가를 지급하여 구매한 쿠폰은 유효기간이 만료된 후에도 구매일로부터 5년 내에 "플랫폼"의 쿠폰 운영정책에 따라 환불을 신청할 수 있습니다.<br><br>
⑤ “플랫폼”은 재화의 종류, 거래 금액 등 다양한 조건에 따라 쿠폰의 사용을 제한할 수 있으며, 회원 탈퇴시 무상으로 제공된 미사용 쿠폰은 자동 소멸됩니다.<br>
단 회원이 유상으로 구매한 쿠폰이 있을 경우, "플랫폼"은 쿠폰 운영정책에서 명시한 바에 따라 환불 처리를 진행합니다.<br>
⑥ 회원이 부정한 방법으로 쿠폰을 획득한 경우(부정취득) 또는 부정한 방식으로 사용(부정사용)하였음이 확인될 경우, “플랫폼”은 해당 회원에게 사유를 명시하여 통지하고 소명 기회를 부여합니다.<br>
1. 부정취득 : 쿠폰 제공 사유(서비스 이용 실적, 이벤트 참여 내역, 쿠폰 유상 구매 등)가 실제로 발생하지 않았음에도 쿠폰을 취득한 경우를 의미합니다. 그러나 시스템 오류 등 회원의 귀책사유 없이 쿠폰이 제공된 경우는 이에 해당하지 않습니다.<br>
2. 부정사용 :<br>
- 회원이 본인 거래가 아닌 타인 명의의 거래에 대하여 쿠폰을 사용한 경우<br>
- 회원이 쿠폰을 타인에게 매매 양도하거나 이와 실질적으로 동일한 행위를 한 경우<br>
- 회원이 부정취득한 쿠폰을 사용하여 "플랫폼" 의 상품이나 서비스 이용료 등을 결제한 경우<br>
- 기타 회원이 이 약관에 위배되는 방식으로 쿠폰을 사용하는 경우<br><br>
⑦ 회원은 해당 사유 발생에 대한 통지를 받은 날로부터 최대 [7일] 이내에 "플랫폼"이 통지한 부정사용, 부정취득 사유가 자신의 고의 또는 과실에 기한 것이 아님을 소명할 수 있습니다. "플랫폼"은 회원의 소명 내용을 심사하여 회원의 주장이 타당하다고 판단하는 경우 회원으로 하여금 정상적으로 쿠폰을 이용할 수 있도록 합니다.<br><br>
⑧ 회원이 전항의 기간 내에 부정사용·부정취득 사실을 소명하지 않거나 소명 내용이 부적합하다고 판단된 경우, "플랫폼"은 부정취득한 쿠폰의 회수 및 회원자격 제한, 회원자격 정지 등의 조치를 취할 수 있습니다.<br><br>
⑨ 회원이 부정취득한 쿠폰으로 "플랫폼"의 서비스 이용료 등을 결제하는 부당이득을 취한 경우 "플랫폼"은 해당 회원에 대하여 회원자격 제한 등의 조치와 함께 민·형사상 조치를 취할 수 있습니다.  또한 부당이득을 취한 회원에 대한 "플랫폼" 파트너십 업체, 제휴 업체 등 제3자의 법적 조치에 관하여 "플랫폼"은 책임을 지지 않습니다.<br><br>
⑩ 시스템 오류로 인하여 제공된 쿠폰은 사전 고지 없이 회수될 수 있습니다. "플랫폼"은 해당 쿠폰을 회수한 후 쿠폰 회수 사유, 해당 사유의 발생 일시, 회수 대상 쿠폰 등을 명시하여 이 약관 제8조에서 정한 방식으로 통지합니다.<br>
⑪ 회원이 쿠폰을 사용한 구매를 취소 또는 환불할 경우 해당 쿠폰의 사용 여부 및 유효기간에 따라 복원 가능 여부가 결정되며, 유효기간이 지난 무상 쿠폰은 복원되지 않습니다. 단 회원이 유상으로 구매한 쿠폰은 본조 제4항 단서에 따라 환불을 신청할 수 있습니다.<br><br>

<h3>제26조(솔닥복권의 사용)</h3>
① “플랫폼”은 “솔닥 챌린지”를 이용하는 회원이 서비스 내 특정 행위를 완료하는 것을 조건으로 서비스 내 공지사항 또는 운영정책에서 명시한 바에 따라 경품 응모에 사용할 수 있는 솔닥복권을 제공할 수 있습니다.<br><br>
② 솔닥복권의 부여 방식, 사용 조건, 유효기간 등은 “플랫폼”에서 정한 솔닥복권 운영정책에 따릅니다.<br><br>
③ 회원은 본인의 거래에 대해서만 솔닥복권을 사용할 수 있으며, 타인에게 매매·양도하거나, 실질적으로 동일한 행위를 하여서는 안 됩니다.<br><br>
④ 솔닥복권은 매월 갱신되며, 유효기간이 만료된 솔닥복권은 복구 및 재사용이 불가합니다.<br><br>
⑤ 회원 탈퇴시 무상으로 제공된 미사용 솔닥복권은 자동 소멸됩니다.<br><br>
⑥ 회원이 부정한 방법으로 솔닥복권을 획득한 경우(부정취득) 또는 부정한 방식으로 사용(부정사용)하였음이 확인될 경우, “플랫폼”은 해당 회원에게 사유를 명시하여 통지하고 소명 기회를 부여합니다.<br>
1. 부정취득 : 솔닥복권 제공 사유(서비스 이용 실적, 이벤트 참여 내역등)가 실제로 발생하지 않았음에도 솔닥복권을 취득한 경우를 의미합니다. 그러나 시스템 오류 등 회원의 귀책사유 없이 솔닥복권이 제공된 경우는 이에 해당하지 않습니다.<br>
2. 부정사용 :<br>
- 회원이 솔닥복권을 타인에게 매매 양도하거나 이와 실질적으로 동일한 행위를 한 경우<br>
- 자동화 도구·스크립트 사용, 허위 정보 입력, 타인의 휴대전화번호 사용, 서비스 취약점 악용<br>
- 기타 회원이 이 약관에 위배되는 방식으로 솔닥복권을 사용하는 경우<br><br>
⑦ 회원은 해당 사유 발생에 대한 통지를 받은 날로부터 최대 [7일] 이내에 "플랫폼"이 통지한 부정사용, 부정취득 사유가 자신의 고의 또는 과실에 기한 것이 아님을 소명할 수 있습니다. "플랫폼"은 회원의 소명 내용을 심사하여 회원의 주장이 타당하다고 판단하는 경우 회원으로 하여금 정상적으로 솔닥복권을 이용할 수 있도록 합니다.<br><br>
⑧ 회원이 전항의 기간 내에 부정사용·부정취득 사실을 소명하지 않거나 소명 내용이 부적합하다고 판단된 경우, "플랫폼"은 부정취득한 솔닥복권의 회수 및 회원자격 제한, 회원자격 정지 등의 조치를 취할 수 있습니다.<br><br>
⑨ 회원이 부정취득한 솔닥복권을 사용하여 부당이득을 취한 경우 "플랫폼"은 해당 회원에 대하여 회원자격 제한 등의 조치와 함께 민·형사상 조치를 취할 수 있습니다.  또한 부당이득을 취한 회원에 대한 "플랫폼" 파트너십 업체, 제휴 업체 등 제3자의 법적 조치에 관하여 "플랫폼"은 책임을 지지 않습니다.<br><br>
⑩ 경품 가액에 따라 제세공과금 등 법령상 의무가 발생하는 경우, 관련 비용은 당첨자가 부담하며 회사는 지급 절차를 위해 필요한 정보를 요청할 수 있습니다.<br><br>
⑪시스템 점검, 제휴사 정책 변경, 통신 장애, 천재지변 등 불가항력 또는 운영상 중대한 사유가 있는 경우 회사는 챌린지의 전부 또는 일부를 변경•중단할 수 있습니다. 이로 인하여 발생한 손해에 대하여 회사의 고의 또는 중대한 과실이 없는 한 책임을 부담하지 않습니다.<br><br>
⑫ 경품이 제휴사에서 발행•운영되는 경우, 실제 재화•용역의 하자•사용 제한•A/S 등은 해당 제휴사의 약관 및 정책을 따릅니다. 법령상 회사에 책임이 부과되는 경우를 제외하고 회사는 이에 대한 책임을 부담하지 않습니다.<br><br>

부칙<br>
2025년 9월 10일부터 적용됩니다.<br><br>

</body>
</html>`},
                {title: "개인정보 수집 및 이용동의", html: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>개인정보 수집 및 이용 동의</title>
    <style>
        body {
            font-size: 15px;
            word-break: break-word;
        }

        p {
            word-break: break-word;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }
        th, td {
          border: 1px solid #000;
          padding: 8px;
          vertical-align: top;
        }
        th {
          background-color: #f4f4f4;
          font-weight: bold;
          text-align: center;
        }
        td {
          background-color: #ffffff;
        }
         .content {
            text-align: center;
         }
         .number {
            text-align: right;
         }
         .title { 
            font-size: 20px;
            font-weight: bold;
         }
    </style>
</head>
<body>
  <h1>[개인정보 수집 및 이용 동의]</h1>
솔닥 주식회사는 비대면 진료 서비스 제공을 위하여 아래와 같이 개인정보를 수집ᆞ이용하고, 제3자에게 제공합니다.


<h3>- 개인정보 수집ᆞ이용</h3>
<table>
    <thead>
      <tr>
        <th>가입 형태</th>
        <th>수집 및 이용 목적</th>
        <th>수집 항목</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>카카오 계정 가입</td>
        <td rowspan="5">
          - 회원 가입 및 이용자 식별<br>
          - 가입의사 확인<br>
          - 회원제 서비스 제공에 따른 본인 식별·인증
        </td>
        <td>카카오 식별정보(CI), 중복가입 확인정보(DI), 이메일주소, 휴대전화 번호, 카카오톡 채널 추가 상태 및 내역</td>
      </tr>
      <tr>
        <td>구글 계정 가입</td>      
        <td>로그인 정보 식별 값, 이메일</td>
      </tr>
      <tr>
        <td>PASS 계정 가입</td>        
        <td>로그인 정보 식별 값</td>
      </tr>
      <tr>
        <td>Apple 계정 가입</td>        
        <td>로그인 정보 식별 값</td>
      </tr>
      <tr>
        <td>이메일 계정 가입</td>
        <td>이메일, 비밀번호, 중복가입 확인정보(DI), 식별정보(CI)<br/>
        본인확인 정보 – 이름, 생년월일, 성별, 휴대폰번호
        </td>
      </tr>
      <tr>
        <td>자동 수집 정보</td>
        <td>- 회원 관리<br/>
        - 개인화 서비스 제공<br/>
        - 불법 및 부정 이용 방지<br/>
        - 서비스 이용기록 통계 및 분석  <br/>
        - 서비스 개선 및 신규 서비스 개발 목적<br/>
        - 민원상담, 고충처리, 분쟁 조정을 위한 기록 보존
        </td>
        <td>사용자식별값, 방문 일시, 서비스 이용 기록, 부정 이용 기록, 거래기록, 접속 로그(브라우저 유형, 운영체제), 쿠키, IP주소, MAC주소, 휴대폰 기기고유번호(UDID, UUID), 광고식별자(ADID, IDFA), 단말기 정보(OS, 모델명, 제조사)</td>
      </tr>
      <tr>
        <td>진료 접수/ 예약</td>
        <td>- 비대면/대면 진료 예약 접수<br/>
        - 예약 및 진료 내역 조회<br/>
        - 예약 일정에 대한 고지<br/>
        </td>
        <td>사용자식별값, (예약자의) 이름, 생년월일, 성별, 휴대폰번호, 사전문진(예진지) 정보, 초·재진여부, 진료시간(진료 가능한 날짜·시간), 진료과목, 진료 영상 여부, 진료방식, 진료증상, 병원 정보, 처방전 및 처방 정보</td>
      </tr>
      <tr>
        <td rowspan="3">진료 접수/ 예약 서비스</td>
        <td>- 진료를 위한 사전 문진 정보</td>
        <td>증상에 대한 설명, 증상 사진</td>
      </tr>
      <tr>        
        <td>- 재진 알림 발송<br/>
        - 진료ᆞ온라인 처방을 위한 전달용 자료 수집<br/>
        </td>
        <td>처방날짜, 처방전 교부 번호, 진료과목, 질병코드, 조제약, 복약 안내사항(투약량, 횟수, 일수)</td>
      </tr>
      <tr>
        <td>- 진료 신청 및 접수 처리<br/>
        - 접수 내역의 확인 급여<br/>
        - 수급권자(국민건강보험 가입 상태) 조회 및 보관<br/>
        - 환자명부 등록 보관<br/>
        - 환자의 민감정보 수집<br/>
        - 의약품 처방<br/>
        - 처방전 발행
        </td>
        <td>사용자식별값, (예약자의) 이름, 생년월일, 성별, 휴대폰번호, 주민등록번호[*1], 사전문진(예진지) 정보, 초·재진여부, 진료시간(진료 가능한 날짜·시간), 진료과목, 진료 영상 여부, 진료방식, 진료증상, 병원 정보</td>
      </tr>
      <tr>
        <td rowspan="2">결제 서비스</td>
        <td>결제를 위한 카드 등록 및 결제</td>
        <td>회원ID, 카드사, 카드번호, 카드 소유자, 카드별명, 카드 비밀번호 앞 2자리, 유효기간, 생년월일</td>
      </tr>
      <tr>
        <td>- 배송 서비스</td>
        <td>수령인 이름, 휴대폰 번호, 배송주소</td>
      </tr>
      <tr>
        <td>프로필 등록</td>
        <td>- 진료를 위한 진료 정보 등록<br/>
        - 가족 진료 정보 등록
        </td>
        <td>이름, 생년월일, 성별, 휴대폰번호, 주민등록번호[*1], 키, 몸무게, 사용자와의 관계<br/>
            만 19세 이상 본인인증 필요- (이름, 성별, 연락처)</td>
      </tr>
      <tr>
        <td>배송 서비스</td>
        <td>수령인 이름, 휴대전화 번호, 배송주소</td>
      </tr>
      <tr>
        <td rowspan="2">위임청구 서비스</td>
        <td>위임청구, 위임장 접수</td>
        <td>수진자 성명, 생년월일[*2], (대리 작성 시) 법정대리인 또는 가족 정보(성명, 생년월일, 관계), 작성자 휴대폰번호, 작성자 신분증(주민등록증 또는 운전면허증) 사본 내 개인정보, (운전면허증 사본 제출 시)운전면허번호, (차상위계층 증빙서류 제출 시)증빙서류 사본 내 개인정보</td>
      </tr>
      <tr>
        <td>위임청구 처방전 발행 및 접수</td>
        <td>수진자 성명, 주민등록번호[*2], 휴대폰번호, 법정대리인 이름, 법정대리인 생년월일, 처방전 내 기재 정보</td>
      </tr>
      <tr>
        <td rowspan="2">유전자검사 서비스</td>
        <td>- 병원 진료 서비스 제공(유전자검사 신청 의뢰, 진료내역 확인 및 관리, 상담)<br/>
        - 유전자검사 서비스 운영 및 관리
        </td>
        <td>사용자식별값, (유전자검사 신청자의) 이름, 주소, 휴대폰번호, 생년월일, 성별, 키, 몸무게, 흡연유무</td>
      </tr>
      <tr>
        <td>유전자검사 진료 서비스의 제공</td>
        <td>이용자가 입력한 주민등록번호, (외국인 이용자의 경우) 외국인등록번호 [*1]</td>
      </tr>
    </tbody>
  </table>
<br/>
[*1] 주민등록번호, 고유식별정보의 수집 및 이용 근거: 의료기관과의 업무 위수탁 계약, 국민건강보험법 제12조 제4항 및 의료법 시행령 제42조의2<br/>
[*2] 주민등록번호, 고유식별정보의 수집 및 이용 근거: 국민건강보험법 제49조 제3항, 같은 법 시행령 제81조 제4항<br/>
<h3>- 민감정보 수집ᆞ이용</h3>
<table>
    <thead>
      <tr>
        <th>수집 · 이용 목적</th>
        <th>항목</th>
        <th>보유 · 이용기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>진료를 위한 사전 건강 문진 정보</td>
        <td>성별, 신장, 체중, 알러지 정보, 임신 여부, 혈액형, 흡연, 음주, 활동량, 증상에 대한 설명, 증상 사진, 기존 복약 정보, 과거 병력, 기저질환, 수술 여부, 입원 여부, 부상 여부, 가족력</td>
        <td rowspan="2">개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지. 단, 관련 법령에 따라 별도 보관되는 정보의 경우 해당 법령에 정한 기간까지</td>
      </tr>
      <tr>
        <td>비대면 진료 · 예약 · 처방 · 약 배송 서비스 관리</td>
        <td>진료병원, 진료과목, 진료의사, 진료일시, 진료기록, 증상 정보, 진료를 위한 사전 건강 문진 정보 입력 내용, 진료 영상, 처방전, 복약지도정보</td>
      </tr>
    </tbody>
  </table>
<br/>
※ 위의 민감정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.
<br/>

<h3>- [필수 ]개인정보 제3자 제공</h3>
 <table>
    <thead>
      <tr>
        <th>제공받는 자</th>
        <th>제공 목적</th>
        <th>제공 내용</th>
        <th>보유 · 이용기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td rowspan="1">솔닥 제휴 의료진</td>
        <td>(진료예약, 취소, 진료내역 확인 및 관리, 처방 문의 및 상담), 마케팅[*1]</td>
        <td>이름, 생년월일, 성별, 휴대폰 번호, 환자 문진 정보, 증상 정보, 증상 관련된 첨부 사진 정보, 환자의 과거 진료내역, 진료 영상 기록</td>
        <td rowspan="2">개인정보처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지[*1]. 단, 관련 법령에 따라 별도 보관되는 정보의 경우 해당 법령에 정한 기간까지</td>
      </tr>
      <tr>
        <td rowspan="1">솔닥 제휴 약국</td>
        <td>(처방전 확인 및 조제, 배송, 대리수령, 복약지도, 문의 및 상담)</td>
        <td>이름, 생년월일, 성별, 휴대폰 번호, 처방전, 배송 주소, 보호자 이름, 돌봄센터 직원 이름, 환자와의 관계 정보</td>
      </tr>
      <tr>
        <td rowspan="3">(주)테라젠헬스</td>
        <td>유전자검사 키트의 배송</td>
        <td>익명화된 이름, 주소, 연락처</td>
        <td>수집 일로부터 유전자검사 키트 배송 완료 시까지</td>
      </tr>
      <tr>
        <td>유전자검사 서비스의 제공</td>
        <td>생년월일, 성별</td>
        <td rowspan="2">개인정보처리방침에 따라 서비스 회원 탈퇴 및 이용계약 종료 시 또는 유전자검사 서비스 종료 시</td>
      </tr>
      <tr>
        <td>유전자검사 서비스의 제공</td>
        <td>흡연유무, 키, 몸무게</td>
      </tr>
      <tr>
        <td>이용자가 선택한 각 병의원</td>
        <td>유전자검사 진료 서비스의 제공</td>
        <td>이용자가 입력한 주민등록번호, 이용자의 외국인등록번호 (외국인의 경우)</td>
        <td>개인정보처리방침에 따라 서비스 회원 탈퇴 및 이용계약 종료 시 또는 유전자검사 서비스 종료 시</td>
      </tr>
    </tbody>
  </table>
  <br/>
※ 위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.
<br/>


</body>
</html>`},
                {title: "위치기반 서비스 이용동의", html: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>위치기반 서비스 이용약관</title>
    <style>
        body {
            font-size: 15px;
            word-break: break-word;
        }

        p {
            word-break: break-word;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }
        th, td {
          border: 1px solid #000;
          padding: 8px;
          vertical-align: top;
        }
        th {
          background-color: #f4f4f4;
          font-weight: bold;
          text-align: center;
        }
        td {
          background-color: #ffffff;
        }
         .content {
            text-align: center;
         }
         .number {
            text-align: right;
         }
         .title { 
            font-size: 20px;
            font-weight: bold;
         }
    </style>
</head>
<body>
  <h1>[위치기반 서비스 이용약관]</h1>

<h3>제1조(목적)</h3>
본 약관은 솔닥 주식회사(이하 “회사”)가 운영하는 솔닥 플랫폼 위치기반 서비스(이하 “서비스”)의 이용과 관련하여 회사와 회원의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.<br/>

<h3>제2조(이용약관의 효력 및 변경)</h3>
① 본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사 소정의 절차에 따라 서비스의 이용자로 등록함으로써 효력이 발생합니다.<br/>
② 회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.<br/>
③ 회사는 위치기반서비스의 변경사항을 반영하기 위하여 필요한 경우 등에는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법, 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.<br/>
④ 회사가 약관을 개정할 경우에는 적용일자, 개정사유, 현행약관 및 개정약관의 내용과 개정약관 적용일까지 동의 또는 거부의 의사표시를 하지 아니하면 개정약관에 동의한 것으로 본다는 내용을 각 명시하여 다음과 같은 방법으로 게시 및 통지합니다.<br/>
1. 서비스 홈페이지 등 게시 : 개정약관 적용일 7일 전부터 적용일 전일까지<br/>
⑤ 회사의 전항에 따른 게시 및 통지 후에도 회원이 개정약관 적용일까지 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않을 때에는 회원이 해당 개정약관에 동의한 것으로 봅니다.<br/>

<h3>제3조(관계법령의 적용)</h3>
본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.<br/>

<h3>제4조(서비스의 내용 등)</h3>
① 회사가 제공하는 위치기반서비스 및 개인위치정보의 보유목적과 기간은 아래와 같습니다.<br/>
<table>
    <thead>
      <tr>
        <th>서비스명</th>
        <th>서비스 내용 및 목적</th>
        <th>개인위치정보 보유기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>병원찾기</td>
        <td>사용자에게 근거리의 병원 정보 제공</td>
        <td>기록 시점으로부터 6개월</td>
      </tr>
      <tr>
        <td>약국찾기</td>
        <td>사용자에게 처방약 수령을 위한 근거리의 약국 정보 제공</td>
        <td>기록 시점으로부터 6개월</td>
      </tr>
    </tbody>
  </table>
<br/>

- 회사는 서비스 내 이용자가 병원·의원·약국 찾기 기능을 이용할 때, 이용자의 위치정보를 기반으로 근접한 병원·의원·약국을 지도상에 표시하거나 목록상 우선순위로 표시하는 기능을 제공하기 위해 개인위치정보를 제공받아 이용합니다.<br/>
- 회사는 위치기반 서비스에서 개인위치정보 처리 목적달성 후 지체없이 파기합니다. 다만, 관련 법령에 의한 보관이 필요한 경우 해당 기간만큼 보관합니다.<br/><br/>

② 회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 따라 위치정보 이용·제공사실 확인자료를 자동 기록·보존하며, 해당 자료는 기록 시점으로부터 6개월간 보관합니다.<br/>
③ 회사는 개인위치정보의 이용 또는 제공목적을 달성한 때에는 제2항의 위치정보 이용·제공사실 확인자료를 제외한 개인위치정보를 즉시 파기합니다. 다만, 다른 법률에 따라 보유하여야 하거나 회원이 개인위치정보의 보유에 별도로 동의한 경우에는 회원이 동의한 때로부터 최대 1년간 이를 보유할 수 있습니다.<br/>

<h3>제5조(서비스 추가·변경)</h3>
회사는 서비스의 추가·변경이 필요한 경우, 제4조에 그 내용을 반영하여 제2조 제4항에 따라 게시하여야 합니다.<br/>

<h3>제6조(서비스이용의 제한 및 중지)</h3>
① 회사는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등 사유가 발생한 경우 서비스의 일부 혹은 전부의 이용을 제한하거나 중지할 수 있습니다.<br/>
② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 서비스 홈페이지 등에 게시하고 전자적 형태(전자우편, SMS 등)로 개별 통지하여야 합니다.<br/>
③ 회사가 전항에 따른 게시 및 통지를 할 수 없는 부득이한 사유가 있는 경우 사후에 게시 및 통지할 수 있습니다.<br/>

<h3>제7조(개인위치정보의 이용 또는 제공)</h3>
① 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.<br/>
② 회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 회원에게 고지하고 동의를 받습니다.<br/>
③ 제2항에 따라 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 해당 통신 단말장치 또는 전자우편주소 등으로 매회 회원에게 제공받는 자, 제공일시 및 제공목적(이하 “정보제공내역”이라 합니다)을 즉시 통보합니다.<br/>
④ 단, 아래 각 호에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.<br/>
1. 개인위치정보를 수집한 해당 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우<br/>
2. 회원이 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우<br/>
⑤ 제3항에도 불구하고 회원은 위치정보법 시행령 제24조에 따라 정보제공내역을 30일마다 모아서 통보받는 방법을 선택할 수 있으며, 회원이 회사의 절차에 따라 요청할 경우 전항에 따른 즉시 통보 방법으로 변경할 수 있습니다.<br/>
⑥ 회원은 제1항·제2항·제5항에 따른 동의를 하는 경우 이용·제공목적, 제공받는 자의 범위 및 위치기반서비스 이용약관의 내용 중 일부와 회원의 개인위치정보에 대한 제3자 제공의 경우 통보방법에 대하여 동의를 유보할 수 있습니다.<br/>

<h3>제8조(개인위치정보의 이용 또는 제공의 제한)</h3>
회사는 회원의 동의가 있거나 다음 각 호의 어느 하나에 해당하는 경우를 제외하고는 개인위치정보 또는 위치정보 이용·제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공할 수 없습니다.<br/>
1. 위치기반서비스의 제공에 따른 요금정산을 위하여 위치정보 이용·제공사실 확인자료가 필요한 경우<br/>
2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우<br/>

<h3>제9조(개인위치정보주체의 권리 및 행사방법)</h3>
① 회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 제공받은 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다. 단, 동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 이용·제공사실 확인자료에 한합니다.<br/>
② 회원은 회사에 대하여 언제든지 개인위치정보의 이용 또는 제공의 일시적인 중지를 요구할 수 있고, 회사는 이를 거절할 수 없으며 이를 위한 기술적 수단을 갖추고 있습니다.<br/>
③ 회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 해당 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.<br/>
1. 본인에 대한 위치정보 이용, 제공사실 확인자료<br/>
2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용<br/>
④ 회원은 제1항 내지 제3항의 권리행사를 위해 (고객센터 등 구체적 절차 기술)를 통해 요구할 수 있습니다.<br/>

<h3>제10조(법정대리인의 권리 및 행사방법)</h3>
① 회사는 14세 미만의 회원의 경우, 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대하여 해당 회원과 그 법정대리인 모두의 동의를 받아야 합니다. 이 경우 법정대리인은 제9조에 의한 회원의 권리를 모두 가집니다.<br/>
② 회사는 다음 각 호의 어느 하나에 해당하는 방법으로 법정대리인이 동의했는지를 확인합니다.<br/>
1. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 위치정보사업자등이 그 동의 표시를 확인했음을 법정대리인의 휴대전화 문자메시지로 알리는 방법<br/>
2. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 신용카드·직불카드 등의 카드정보를 제공받는 방법<br/>
3. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법<br/>
4. 동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나, 우편 또는 팩스를 통하여 전달하고 법정대리인이 동의 내용에 대하여 서명날인 후 제출하도록 하는 방법<br/>
5. 동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우편을 전송받는 방법<br/>
6. 전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법<br/>
7. 그 밖에 제1호부터 제6호까지의 규정에 따른 방법에 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법<br/>

<h3>제11조(8세 이하의 아동 등의 보호의무자의 권리·의무 및 행사방법)</h3>
① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.<br/>
1. 8세 이하의 아동<br/>
2. 피성년후견인<br/>
3. 「장애인복지법」 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 「장애인고용촉진 및 직업재활법」 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(「장애인복지법」 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)<br/>
② 제1항에 따른 8세 이하의 아동등의 보호의무자는 8세 이하의 아동등을 사실상 보호하는 자로서 다음 각 호의 어느 하나에 해당하는 자를 말합니다.<br/>
1. 8세 이하의 아동의 법정대리인 또는 「보호시설에 있는 미성년자의 후견 직무에 관한 법률」 제3조에 따른 후견인<br/>
2. 피성년후견인의 법정대리인<br/>
3. 제1항 제3호의 자의 법정대리인 또는 「장애인복지법」 제58조제1항제1호에 따른 장애인 거주시설(국가 또는 지방자치단체가 설치·운영하는 시설로 한정한다)의 장, 「정신건강증진 및 정신질환자 복지서비스 지원에 관한 법률」 제22조에 따른 정신요양시설의 장 및 같은 법 제26조에 따른 정신재활시설(국가 또는 지방자치단체가 설치·운영하는 시설로 한정한다)의 장<br/>
③ 제1항에 따른 동의를 하고자 하는 8세 이하 아동 등의 보호의무자는 각 호의 사항을 기재하여 기명날인 또는 서명한 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.<br/>
1. 8세 이하의 아동 등의 성명, 주소 및 생년월일<br/>
2. 보호의무자의 성명, 주소 및 연락처<br/>
3. 개인위치정보 이용 또는 제공의 목적이 8세 이하의 아동 등의 생명 또는 신체의 보호에 한정된다는 사실<br/>
4. 동의의 연월일<br/>
④ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 제9조에 의한 회원의 권리 전부를 행사할 수 있습니다.<br/>

<h3>제12조(위치정보관리책임자의 지정)</h3>
① 회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다.<br/>
② 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.<br/>

<h3>제13조(손해배상)</h3>
회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.<br/>

<h3>제14조(준거법 및 재판관할)</h3>
① 본 약관은 대한민국 법령에 의하여 규정되고 이행됩니다.<br/>
② 회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.<br/>

<h3>제15조(분쟁의 조정 및 기타)</h3>
① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「위치정보의 보호 및 이용 등에 관한 법률」 제28조의 규정에 의해 방송통신위원회에 재정을 신청할 수 있습니다.<br/>
② 회사 또는 회원은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「개인정보보호법」 제43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.<br/>

<h3>제16조(회사의 연락처)</h3>
회사의 상호 및 주소 등은 다음과 같습니다.<br/>
1. 상 호 : 솔닥 주식회사<br/>
2. 대 표 자 : 김민승, 이호익<br/>
3. 주 소 : 서울시 강남구 압구정로30길 67 3층<br/>
4. 대표전화 : 02-6954-7676<br/>

<h3>부 칙</h3>
<h3>제1조(시행일)</h3>
이 약관은 2025년 2월 19일부터 시행한다.<br/>

<h3>제2조(위치정보관리책임자)</h3>
위치정보관리책임자는 2025년 2월 19일을 기준으로 다음과 같이 지정합니다.<br/>
1. 책임자 : 김민승, 이승도<br/>
2. 연락처 : 02-6954-7676<br/>
3. 이메일 : info@soldoc.co.kr<br/>

</body>
</html>`}
            ]
        }
    },
     methods: {
        resetTimeoutCount: function () {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(this.gohome, 30000);
        },
        clearTimer: function()
        {
            clearTimeout(this.timeoutId);
            this.timerId = null;
        },
        gohome: function() {
            this.clearTimer();
            window.location.href  = '/' + this.$route.params.showcase + '/home'
        },
        allAgreeF: function()
        {
          this.reset();
            this.allAgree = !this.allAgree;
            this.agree1 = this.allAgree;
            this.agree2 = this.allAgree;
            this.agree3 = this.allAgree;
            this.agree4 = this.allAgree;
        },
        agreementContentsView: function(type)
        {
          this.reset();
            this.type = type;
            this.agreementContentsModal = true;
        },
        closeAgreementModal: function()
        {
          this.reset();
            this.type = 0;
            this.agreementContentsModal = false;
        },
        next: function()
        {
          this.reset();           
          this.$emit('next', 1)           
            
        },
        reset: function()
        {
          this.$emit('resetCount')
        }
    },
    watch: {
        agree1: function()
        {
            if(!this.agree1)
            {
                this.allAgree = false;
            }
        },
        agree2: function()
        {
            if(!this.agree2)
            {
                this.allAgree = false;
            }
        },
        agree3: function()
        {
            if(!this.agree3)
            {
                this.allAgree = false;
            }
        },
        agree4: function()
        {
            if(!this.agree4)
            {
                this.allAgree = false;
            }
        }
    }
}
</script>

<style scoped>
    .agreement {
        width: 100%;
        height: 100vh;
        overflow: hidden;    
    }
    .header {
        height: 9vh;
        width: 100%;
        font-size: 2vh;
        color: var(--xi-dark-blue, #173C55);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5%;
        box-sizing: border-box;
    }
    .agree-area {
        box-sizing: border-box;
        padding: 8vh 16vw;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-top: 2px solid var(--xi-gray-2, #C4CBD2);
    }
    .wrapper {
        padding: 6.2vh 5vw;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
    .title {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vh;
        font-style: normal;
        font-weight: 500;
        line-height: 131%;
        letter-spacing: -2.64px;
    }
    .button-next {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        font-size: 1.8vh;
        width: 27vw;
        aspect-ratio: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-gray-2, #C4CBD2);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .button-next-active {
        border-radius: 16px;
        background: var(--xi-dark-blue, #173C55);
        font-size: 2vh;
        width: 43vw;
        aspect-ratio: 3.8;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-gray-0, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }
    .agree-component {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .text1{
        color: var(--xi-dark-gray, #131415);
        font-family: Pretendard;
        font-size: 2.1vh;
        font-style: normal;
        font-weight: 700;
        letter-spacing: -1.12px;
        height: 6vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5vw;
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        width: 100%;
    }
    .text2 {
        color: var(--xi-dark-gray, #131415);
        font-family: Pretendard;
        font-size: 1.8vh;
        font-style: normal;
        font-weight: 500;
        letter-spacing: -0.96px;
        height: 5vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5vw;
        width: 100%;
        margin-top: 0.9vh;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Agreement.vue